import React from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import moment from 'moment'

const year = moment().year()

const Footer = props => {
	return (
		<footer className="Footer">
			<div className="container">
				<div className="columns is-centered is-vcentered">
					<div className="column is-one-third-desktop">
						<p className="buttons round is-left">
							<a
								href="https://www.facebook.com/poolwerx/"
								className="button is-dark is-outlined"
								target="_blank noopener noreferrer"
							>
								<span className="icon">
									<FontAwesomeIcon icon={['fab', 'facebook-f']} />
								</span>
							</a>
							<a
								href="https://www.instagram.com/poolwerx/"
								className="button is-dark is-outlined"
								target="_blank noopener noreferrer"
							>
								<span className="icon">
									<FontAwesomeIcon icon={['fab', 'instagram']} />
								</span>
							</a>
							<a
								href="https://twitter.com/poolwerx/"
								className="button is-dark is-outlined"
								target="_blank noopener noreferrer"
							>
								<span className="icon">
									<FontAwesomeIcon icon={['fab', 'twitter']} />
								</span>
							</a>
							<a
								href="https://www.linkedin.com/company/poolwerx-corporation-pty-ltd/"
								className="button is-dark is-outlined"
								target="_blank noopener noreferrer"
							>
								<span className="icon">
									<FontAwesomeIcon icon={['fab', 'linkedin-in']} />
								</span>
							</a>
						</p>
					</div>
					<div className="column is-one-third-desktop">
						<p>
							Copyright <FontAwesomeIcon icon="copyright" /> Poolwerx Australia
							Pty Ltd {year}
						</p>
					</div>
					<div className="column is-one-third-desktop">
						<p className="buttons links is-right">
							<a
								className="button is-light"
								href="https://www.poolwerx.com.au/privacy-policy/"
							>
								Privacy Policy
							</a>
							<a
								className="button is-light"
								href="https://www.poolwerx.com.au/terms-of-trade/"
							>
								Terms
							</a>
						</p>
					</div>
				</div>
			</div>
		</footer>
	)
}

export default Footer
